import { ButtonHTMLAttributes } from "react";

import { AuthModalButtonContainer } from "./styles";
import { IConsolePageButtonVariants } from "./types";

interface IConsolePageButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant: IConsolePageButtonVariants;
}

export const AuthModalButton = ({ ...props }: IConsolePageButtonProps) => {
  return <AuthModalButtonContainer {...props} />;
};
